import { Grid2, Typography } from "@mui/material";

import MealIcon from "../../../../mealPlanPage/MealIcon";
import { Meal } from "../../../../mealPlanPage/mealPlan.types";
import styles from './mealsPerMealtype.module.css';

const MealsPerMealtype = ({ mealType, meals }: { mealType: string, meals: Meal[] }) => {

  if (!meals || !meals?.length) return null;

  const recipeNameList = meals.map(({ Recipes_E3: { name } }: any) => name).join(',');

  return <Grid2 className={styles.meals_container}>
    <MealIcon height={24} mealType={mealType} width={24} />
    <Grid2 className={styles.meal_recipes}>
      <Typography noWrap variant="caption4LightOutfit">
        {recipeNameList}
      </Typography>
    </Grid2>
  </Grid2>
}

export default MealsPerMealtype;